import { type ImageLoaderProps } from 'next/image';

import {
  getImageKitTransformKey,
  joinImageKitTransforms,
  parseImageKitTransforms,
} from '@/app/components/media/app-image/shared/imagekit-transform';
import {
  getQueryParams,
  mergeQuery,
} from '@/app/components/media/app-image/shared/url-query';

export const nextImageKitLoader = ({
  src,
  width,
  quality,
}: ImageLoaderProps): string => {
  if (!src) return '';

  const queryParams = getQueryParams(src);
  let transforms = parseImageKitTransforms(queryParams.tr);

  if (typeof width === 'number' && width > 0) {
    transforms = transforms.filter(
      (transform) => getImageKitTransformKey(transform) !== 'w'
    );
    transforms.push(`w-${width}`);
  }

  if (typeof quality === 'number' && quality > 0) {
    transforms = transforms.filter(
      (transform) => getImageKitTransformKey(transform) !== 'q'
    );
    transforms.push(`q-${quality}`);
  }

  const transformed = joinImageKitTransforms(transforms);
  const patch: Record<string, string> = transformed ? { tr: transformed } : {};
  return mergeQuery(src, patch);
};
